
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Group 4322","xmlns":"http://www.w3.org/2000/svg","width":"50","height":"50"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 3941"}},[_c('g',{attrs:{"data-name":"Group 3494"}},[_c('g',{attrs:{"data-name":"Group 264"}},[_c('circle',{attrs:{"data-name":"Ellipse 12","cx":"25","cy":"25","r":"25","fill":"#fff"}})])]),_c('g',{attrs:{"data-name":"Group 3805"}},[_c('path',{attrs:{"data-name":"Path 1585","d":"M23.266 14l2.943 2.939-6.295 6.3H37v4.16H20.018l6.191 6.191-2.942 2.942L12 25.266z","fill-rule":"evenodd"}})])])])
          )
        }
      }
    